export default {
	termsAndConditions: {
		lastUpdate: 'Востаннє оновлено: 10 червня 2024 р',
		content: `
		<p>Умови, які ви знайдете нижче, важливі, оскільки:</p>
		<ul>
			<li>Вони встановлюють свої законні права на {siteName}.</li>
			<li>Поясніть права, які ви надаєте нам, коли використовуєте {siteName}.</li>
			<li>
				Вони описують правила, яких кожен повинен дотримуватися під час використання {siteName}.
			</li>
		</ul>
		<p>
			Уважно прочитайте ці Умови, а також наші {privacyPolicyLink} та будь-які інші
			документи, зазначені в цих Умовах.
		</p>
		<p>Розпочнемо...</p>
		<h3>1. ВСТУП ТА ДАНІ ПРО {siteNameUpper}.</h3>
		<p>
			Веб-сайт {websiteLink} (далі «Веб-сайт») належить компанії
			{siteName} S.L (надалі "{siteName}"), компанія
			зареєстрована відповідно до законодавства Іспанії з адресою Avenida de
			Cerdanyola, nº 75, 1º, Sant Cugat del Vallès (Барселона), власник номера CIF
			B-56.768.260 і зареєстровано в Торговому реєстрі Барселони в томі
			49065, Фоліо 0033, Арк. В-606324, 1-ша реєстрація.
		</p>
		<p>
			{siteName} надає веб-сайт у ваше розпорядження, щоб ви могли перейти
			взнайте нас краще, знайте послуги, які ми надаємо, і при бажанні ви можете зв'язатися
			і, якщо це необхідно, укласти з нами договір.
		</p>
		<h3>2. МЕТА ТА ОБЛАСТЬ ЗАСТОСУВАННЯ УМОВ ВИКОРИСТАННЯ</h3>
		<p>
			Ці умови використання разом із {privacyPolicyLink} і
			{cookiesPolicyLink}, правова база, яка регулює використання веб-сайту
			{websiteLink}. Ці умови використання будуть доступні для вас на веб-сайті
			англійською мовою, щоб ви могли будь-коли переглянути, архівувати або роздрукувати їх
			коли схочеш.
		</p>
		<p>
			Щоб знати будь-які запитання щодо лікування, яке проводить {siteName}.
			ваших особистих даних, відвідайте наші {privacyPolicyLink} і {cookiesPolicyLink}.
			Обидва поліси також будуть доступні для вас англійською мовою, щоб ви могли
			зверніться до них, архівуйте або роздрукуйте їх у будь-який час.<br />
			{siteName} використовує сторонні файли cookie на Веб-сайті. Щоб дізнатися більше
			про тип файлів cookie, які використовуються на веб-сайті {websiteLink}, їх призначення та спосіб
			щоб налаштувати ваш браузер, якщо ви не хочете, щоб ми використовували ці файли cookie,
			відвідайте нашу {cookiesPolicyLink}.
		</p>
		<p>
			Обидві ці умови використання, а також {privacyPolicyLink} і 
			{cookiesPolicyLink} підготовлено відповідно до положень чинного законодавства
			чинні нормативні акти, зокрема Закон 34/2002 про послуги
			Інформаційне суспільство та електронна комерція та Регламент (ЄС) 2016/679 від
			Європейського Парламенту та Ради від 27 квітня 2016 р. щодо
			захист фізичних осіб щодо обробки персональних даних
			даних і вільний обіг цих даних і за якою Директива 95/46 / CE
			скасовується.
		</p>
		<h3>3. ДОСТУП ДО ВЕБ-САЙТУ ТА ПРИЙНЯТТЯ</h3>
		<p>
			Доступ до Веб-сайту безкоштовний, за винятком частини, пов’язаної з вартістю
			підключення через телекомунікаційну мережу Інтернет
			постачальника доступу, з яким ви уклали договір. Ви можете вільно переглядати веб-сайт
			і отримуйте доступ до нього скільки завгодно разів. Для доступу та навігації веб-сайтом,
			вам не потрібно реєструватися, за винятком випадків, коли ви хочете найняти послугу.
		</p>
		<p>
			Використання веб-сайту надає вам статус користувача веб-сайту
			(далі «Користувач») і передбачає вашу повну та беззаперечну згоду
			ці умови використання, а також {privacyPolicyLink} і {cookiesPolicyLink}
			веб-сайту. Крім того, ви погоджуєтеся не використовувати Сервіс у незаконних цілях
			цілей.
		</p>
		<p>
			Заходячи на веб-сайт і переглядаючи його, ви заявляєте під своїм
			відповідальність за те, що ви досягли повноліття та маєте необхідні юридичні
			можливість доступу до веб-сайту та використання його, також заявляючи, що ви повністю
			зрозуміти та прийняти ці умови використання без застережень.
		</p>
		<p>
			З іншого боку, ми повідомляємо, що з юридичних причин ми архівуємо
			електронні документи, в яких оформляються закупівлі. Ви можете отримати доступ
			ці документи в будь-який час, надіславши запит за адресою: {supportLink}.
		</p>
		<h3>4. УМОВИ ВИКОРИСТАННЯ ВЕБ-САЙТУ</h3>
		<p>
			Користувач погоджується використовувати Веб-сайт відповідно до цих умов використання,
			чинне законодавство та добросовісність. Таким чином, користувач відповість на {siteName}.
			 і перед будь-якою третьою стороною за завдані збитки та збитки
			використання всупереч цим умовам, законодавству та добросовісності
			Користувачем Сайту.
		</p>
		<h3>5. ОПИС ПОСЛУГИ</h3>
		<p>
			За допомогою Сервісу {siteName} дозволяє підписатися на сервіс
			виконувати редагування зображення.
		</p>
		<p>
			Мова, якою укладено договір між {siteName} і покупцем
			буде зроблено висновок про країну походження.<br />
			Процес покупки в онлайн-сервісі буде наступним:
		</p>
		<ol>
			<li>Ви повинні зареєструватися на веб-сайті за допомогою імені користувача та пароля.</li>
			<li>
				Під час реєстрації користувачеві необхідно вибрати один із планів оплати
				у розділі «Ціни» та отримають кредити залежно від
				обраний план. Кожен кредит дозволить вам редагувати одне зображення.
			</li>
			<li>
				Після покупки послуги користувач отримує адміністрування
				панель, де вони знайдуть:
				<ul>
					<li>
						Розділ зі списком усіх зображень, які були оброблені, є
						можна редагувати його скільки завгодно разів і завантажувати на свій
						пристрій.
					</li>
					<li>
						Розділ Плани та платежі для перегляду рахунків-фактур і скасування
						підписка.
					</li>
					<li>Розділ «Мій обліковий запис», де можна змінити параметри облікового запису.</li>
				</ul>
			</li>
		</ol>
		<p>
			Після того, як покупка послуги буде здійснена, вона буде підтверджена
			надсилання електронного листа протягом максимум 24 годин на вказану вами адресу
			зазначено. Там буде вказано послугу, як скасувати підписку, її
			сума, відповідні податки, форма оплати та відповідні умови та
			умови.
		</p>
		<h4>5.1 Підписка</h4>
		<p>
			Вартість підписки на послугу залежить від обраного тарифного плану та буде
			автоматично продовжується на той самий період часу до його припинення.
			Якщо ви не скасуєте свою підписку, ви дозволяєте нам завантажувати
			відповідну плату за річну підписку у вашому способі оплати.
		</p>
		<p>
			Ви можете будь-коли скасувати підписку на Службу, і ви це зробите
			мати доступ до нього до кінця річного розрахункового періоду. до
			в межах, дозволених законом, виплати не повертаються і ми не надаємо
			відшкодування або кредити за часткові річні періоди підписки.
		</p>
		<h3>6. ЦІНА ТА ПОДАТКИ</h3>
		<p>
			Ціни на товари, які пропонуються на сайті {siteName}, вказані в євро
			(€) або валюта країни, в якій здійснено покупку, Значення
			Податок на додану вартість (ПДВ), що діє на момент покупки, стягується з ціни
			продуктів.
		</p>
		<p>
			У будь-якому випадку операція може бути звільнена або не обкладається ПДВ залежно від
			вашу країну проживання або умови, в яких ви дієте. З цієї причини,
			у деяких випадках остаточна ціна замовлення може бути змінена відносно
			показаний один.<br />
			Покупки, здійснені суб'єктами, звільненими від сплати ПДВ, будуть позначати це
			надсилання номера платника ПДВ/NIF електронною поштою на {supportLink} без запису
			покупки із зазначеним податком.
		</p>
		<h3>7. СПОСІБ ОПЛАТИ</h3>
		<p>
			Онлайн оплату придбаної послуги можна здійснити кредитною або дебетовою карткою.
			У цьому сенсі {siteName} повідомляє про це власникам кредитних і дебетових карток
			транзакції в інтернет-магазині здійснюються за допомогою безпечної оплати
			шлюз, що використовує технологію SSL для гарантування безпеки передачі даних.
		</p>
		<h3>8. ПРАВО НА ВІДМІН ТА ПОВЕРНЕННЯ КОШТІВ</h3>
		<h4>8.1. Право на відмову</h4>
		<p>
			Враховуючи тип продукту, що продається в нашому онлайн-сервісі, програмне забезпечення в цифровому вигляді
			форматі QR, право на відмову не застосовуватиметься відповідно до
			стаття 103, літера m) Королівського законодавчого указу 1/2007 від 16 листопада
			що переглянутий текст Загального закону про захист прав споживачів і
			Затверджено закони про користувачів та інші додаткові закони.
		</p>
		<h4>8.2. Відшкодування</h4>
		<p>
			Незалежно від обраного користувачем плану, суми, сплачені користувачем і до
			обсяг, дозволений законом, не повертається.
		</p>
		<p>
			Контрактна послуга не може бути призначена або передана іншим користувачам
			сервіс.
		</p>
		<p>
			У будь-якому випадку користувач може користуватися послугами за контрактом до кінця
			договірний період.
		</p>
		<h3>9. ТЕРМІН ДІЇ ПРОПОЗИЦІЙ</h3>
		<p>
			Послуги, які пропонуються в Сервісі, і їх ціни будуть доступні для
			придбати, поки вони знаходяться в каталозі послуг, що відображається через це
			веб-сайт.
		</p>
		<p>
			У будь-якому випадку {siteName} залишає за собою право вносити зміни
			вважає доцільним у Сервісі, маючи можливість оновлювати продукти та послуги
			в залежності від ринку.
		</p>
		<p>
			{siteName} залишає за собою право змінювати ціни без попереднього повідомлення. ми
			повідомляємо, що незважаючи на оновлення цін на
			Сервіс, вони можуть містити помилки. Ми оперативно виправимо будь-які помилки, які
			з’являться, але вони не будуть обов’язковими для Служби.
		</p>
		<h3>10. БЕЗПЕКА</h3>
		<p>
			Як зазначено вище, вся процедура покупки, а також трансмісія
			ваших персональних даних і платіжних систем, здійснюється на захищеній сторінці та
			у зашифрований спосіб через протокол SSL.
		</p>
		<p>
			Ми гарантуємо безпеку Сервісу відповідно до чинних
			технологічні знання. Однак {siteName} не може гарантувати повну інформацію
			майбутня безпека Сервісу. У будь-якому випадку, ми обіцяємо виправити і
			запровадити відповідні коригувальні заходи для виправлення можливої безпеки
			порушення якнайшвидше.
		</p>
		<p>
			Ви погоджуєтеся повідомити {siteName} негайно електронною поштою {supportLink}
			будь-якої ситуації, яка може призвести до видавання себе за особу користувача.
		</p>
		<h3>11. МОДИФІКАЦІЇ ТА НЕКРУСНІСТЬ</h3>
		<p>
			Ми також можемо оновити положення та умови Сервісу в майбутньому
			як особливості та функції самого Сервісу.
		</p>
		<p>
			Про зміни в умовах ми повідомимо вас шляхом розміщення повідомлення
			на видному місці на нашому веб-сайті та/або електронною поштою.
		</p>
		<p>
			Якщо оголошено будь-який пункт, включений у ці положення та умови, повністю або
			частково, недійсним або неефективним, це вплине лише на зазначене положення або його частину
			того, що є нульовим або неефективним. Умови будуть діяти
			все інше, що має таке положення, або його частина, на яку впливає
			не розміщується.
		</p>
		<h3>12. ПРЕТЕНЗІЇ ТА ДІЇ, ЩО ВИТЕКАЮТЬ З КОНТРАКТУ</h3>
		<p>
			Наскільки це можливо, ця Служба регулюється законодавством Іспанії.<br />
			З метою спрощення вирішення позовів у порядку цивільного судочинства та
			зменшити витрати, ми не виключаємо можливості підпорядкувати себе an
			Арбітражний суд Третейського суду торгово-промислових палат і
			Промисловість. У цьому сенсі та відповідно до чинних норм,
			 {siteName} повідомляє про існування європейської системи вирішення спорів в Інтернеті
			платформа, яка полегшує позасудове вирішення таких спорів для
			договори, також укладені онлайн між споживачами та послугами Інтернету
			провайдерів. Доступ до цієї платформи можна отримати через такий веб-сайт:
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13. ПРАВА ІНТЕЛЕКТУАЛЬНОЇ ТА ПРОМИСЛОВОЇ ВЛАСНОСТІ</h3>
		<p>
			Веб-сайт та його вміст підлягають захисту в застосуванні
			діючі національні норми інтелектуальної та/або промислової власності, як
			а також у застосуванні міжнародних конвенцій, що застосовуються в такому
			питання. {siteName} є власником або належним чином ліцензував усі
			Права інтелектуальної та промислової власності на Веб-сайт та його вміст.
		</p>
		<p>
			Будь-яка форма відтворення, розповсюдження, оприлюднення, перетворення,
			надання доступності та, загалом, будь-який інший акт експлуатації чи ні
			для комерційних цілей Веб-сайту або його вмісту без попереднього
			явна згода {siteName}. Категорично заборонено видаляти
			ідентифікаційні дані {siteName} як власника Intellectual та
			Права промислової власності на Веб-сайт або його вміст.
		</p>
		<p>
			{siteName} зберігає за собою всі права інтелектуальної та промислової власності
			над Веб-сайтом та його вмістом, також залишаючи за собою виконання будь-яких юридичних
			дії, які йому відповідають, щоб припинити, запобігти або переслідувати будь-які
			незаконне використання веб-сайту або його вмісту. Ні в якому разі і під ні
			обставин не робить доступ до Веб-сайту або його використання Користувачем або третіми особами
			сторони становлять або передбачають передачу будь-якого роду {siteName}
			права інтелектуальної або промислової власності на веб-сайт або його вміст.
			Ні в якому разі відсутність вимог {siteName} припинити використання
			Веб-сайт або його вміст можуть бути незаконними або суперечити цим умовам
			розуміти як мовчазну згоду {siteName} на таке використання або як відмову
			здійснення будь-яких юридичних дій, які можуть цьому відповідати.
		</p>
		<h3>14. ВІДПОВІДАЛЬНІСТЬ ТА ГАРАНТІЇ</h3>
		<p>
			Користувач повинен використовувати Веб-сайт та його вміст відповідно до
			положень цих умов використання, чинного законодавства та добросовісності. Будь-який
			використання веб-сайту або його вмісту всупереч цим загальним умовам
			законом або добросовісністю прямо заборонено, незалежно від того, чи має таке використання
			економічна мета чи ні.<br />
			Користувач несе відповідальність за будь-які збитки або шкоду, заподіяну {siteName}
			 або третім сторонам, отримані прямо чи опосередковано в результаті будь-якого використання
			що Користувач робить веб-сайт або його вміст суперечать цим
			умови, закон, мораль, громадський порядок або добросовісність.
		</p>
		<p>
			Щоб Веб-сайт і його вміст були доступні Користувачеві, {siteName}
			 потребує послуг, що надаються третіми сторонами. Цілком можливо, що
			незважаючи на зусилля {siteName}, щоб веб-сайт був доступним
			і доступний для користувачів, його доступність може бути призупинена, перервана або
			скасовано з причин, не пов’язаних із {siteName}. Ось чому {siteName}
			не гарантує відсутність перебоїв або помилок у доступі до
			Веб-сайт або його вміст, а також те, що вони оновлюються чи завжди відображаються
			їх остання версія. Отже, {siteName} відхиляє будь-які
			відповідальність за збитки, які можуть бути заподіяні Користувачеві або третім особам
			в результаті призупинення, переривання, відсутності безперервності, збою мережі
			або відключення Веб-сайту.
		</p>
		<p>
			Ні в якому разі та ні за яких обставин {siteName} не несе відповідальності за
			збитки або збитки, завдані користувачеві з причин, не пов’язаних із {siteName}
			 як приклад і ні в якому разі не обмежуючи, природний
			катастрофи, ситуації непереборної сили або надзвичайної необхідності, віруси, шкідливі
			компоненти, збої в роботі браузера, зриви мережі, вторгнення в комп’ютер або
			атаки третіх сторін.
		</p>
		<h3>15. ПОСИЛАННЯ</h3>
		<p>
			Веб-сайти, платформи, форуми, чати, блоги чи зовнішні соціальні мережі, які
			посилання або посилання на веб-сайт повинні чітко повідомляти, що вони не мають
			дозвіл або нагляд за {siteName}, а також посилання або
			посилання не тягне за собою, не припускає та не передбачає будь-якого зв’язку між {siteName}
			 веб-сайти, платформи, форуми, чати, блоги або зовнішні
			соціальні мережі, які посилаються або посилаються на Веб-сайт.
		</p>
		<p>
			У будь-якому випадку будь-яке посилання, призначене для Веб-сайту, має бути спрямованим
			безпосередньо на домашню сторінку або домашню сторінку Веб-сайту, натиснувши URL-адресу
			веб-сайту, що покриває весь екран домашньої сторінки або сторінки початку
			веб-сайту, щоб посилання було абсолютним і повним без використання
			рамки, рамки або гіперпосилання. {siteName} ні в якому разі не відповідає
			і за будь-яких обставин до вмісту, інформації чи даних, пов’язаних із
			веб-сайт, його вміст або будь-який інший матеріал, що міститься на веб-сайтах, платформах,
			форуми, чати, блоги або сторонні соціальні мережі, які посилаються або посилаються на
			Веб-сайт.
		</p>
		<p>
			Категорично заборонено створювати посилання або посилання на веб-сайт із веб-сайтів,
			платформи, форуми, чати, блоги чи соціальні мережі, що суперечать закону, моралі
			і добрі звичаї, особливо з порнографічними, незаконними, незаконними або
			вміст, що порушує права людини.
		</p>
		<p>
			З іншого боку, Веб-сайт може містити посилання на сторонні веб-сайти,
			платформи, форуми, чати, блоги чи соціальні мережі. {siteName} ні
			мати людські та/або технічні засоби, щоб знати чи контролювати інформацію та
			вміст, який з’являється на сторонніх веб-сайтах. Тому ні в якому разі {siteName}
			 нести відповідальність за вміст сайтів, на які посилаються, і під №
			обставини, зазначені посилання можуть вважатися ефективним знанням вмісту
			сайтів, на які вони посилаються.
		</p>
		<h3>16. ЗАХИСТ ДАНИХ</h3>
		<p>
			Як зазначено в {privacyPolicyLink}, {siteName} зобов’язується використовувати Користувача
			даних, поважати їх конфіденційність і використовувати їх відповідно до
			мети лікування, а також виконувати свої зобов'язання щодо його збереження.
			і адаптувати всі заходи, щоб уникнути зміни, втрати, обробки або несанкціонованого
			доступу відповідно до положень чинного законодавства щодо
			захист персональних даних.
		</p>
		<p>
			Веб-сайт включає відповідні заходи безпеки та використовує галузевий стандарт
			технологія підвищення безпеки, цілісності, повноти, точності та
			захист персональних даних, які він зібрав і встановив
			розумні запобіжні заходи для захисту цієї інформації від можливої втрати або
			неправильне використання. Його правила щодо захисту даних і безпеки періодично переглядаються
			і вдосконалюється, коли це необхідно, і він прагне гарантувати, що лише авторизовані
			особи можуть отримати доступ до інформації, наданої Користувачем.
		</p>
		<p>
			Щоб дізнатися більше про лікування та лікування, яке проводить {siteName}
			 ваших даних, прочитайте наші {privacyPolicyLink} і {cookiesPolicyLink}.
		</p>
		<h3>17. ТРИВАЛІСТЬ ТА МОДИФІКАЦІЯ</h3>
		<p>
			Ці умови використання залишатимуться в силі протягом усього періоду їх дії
			користувачів, так що як тільки вони повністю або частково змінені або оновлені,
			ці умови припиняють свою дію, будучи новими умовами використання
			ті, які далі регулюють використання веб-сайту.
		</p>
		<p>
			{siteName} залишає за собою право переглядати, змінювати або оновлювати їх
			умови використання в будь-який час. У разі будь-якої зміни цих умов
			використання з будь-якої причини, {siteName} повідомить користувачів на домашній сторінці
			мережі про зазначену обставину, щоб вони були належним чином поінформовані та могли проконсультуватися
			перегляди, модифікації або оновлення поточних умов використання
			ваше задоволення.
		</p>
		<h3>18. ЗАГАЛЬНЕ</h3>
		<p>
			Ні в якому разі і ні за яких обставин не може бути здійснено Ваші права
			{siteName} розуміти як відмову від них.
		</p>
		<p>
			Заголовки, що містяться в цих умовах, є лише орієнтовними або
			інформативні, щоб вони не впливали, не кваліфікували та не розширювали інтерпретацію
			цього.
		</p>
		<p>
			У випадку, якщо будь-який із пунктів, що містяться в цих умовах, був
			оголошені недійсними, неправомірними або такими, що не підлягають виконанню, повністю або частково, судовим рішенням
			або адміністративного органу, зазначена декларація окремо вплине на пункт
			під питанням, вважаючи його недійсним і без оголошення недійсності, зловживання або
			незастосовність поширюється за будь-яких обставин на решту
			умови, які будуть існувати.
		</p>
		<p>
			Ці умови використання, а також {privacyPolicyLink} і {cookiesPolicyLink}
			постійно регулюються діючими іспанськими правилами.
		</p>
		<h3>19. ОБСЛУГОВУВАННЯ КЛІЄНТІВ</h3>
		<p>
			Для будь-яких роз’яснень, інцидентів або претензій ви можете зв’язатися з нами за допомогою:<br />
			Електронна адреса: {supportLink}<br />
			Поштова адреса: пр. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain.
		</p>`
	},
	privacyPolicy: {
		lastUpdate: 'Востаннє оновлено: 10 червня 2024 р',
		content: `
			<h3>1. Відповідальна сторона та опис</h3>
			<h5>1.1. Відповідальний</h5>
			<p>Особою, відповідальною за обробку цього сайту, є Remove Background S.L (далі «Видалити фон» 
			або Служба), з адресою просп. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain.</p>
			<p>NIF: B56768260<br> Електронна пошта: {supportLink}</p>

			<h5>1.2. Опис</h5>
			<p>Прийняття політики конфіденційності Remove Background (надалі «Політика конфіденційності») є необхідною умовою 
				для використання нашого веб-сайту та надання послуги (надалі «Сервіс»).<br>
				Ця Політика конфіденційності регулює збір, обробку та використання вашої особистої та неособистої інформації 
				як користувач Remove Background, починаючи з дати набуття чинності, зазначеної в заголовку.<br>
				Щоб обробляти ваші персональні дані, Remove Background дотримується чинного місцевого та європейського законодавства, 
				а також положення про його виконання.</p>


			<h3>2. Зібрана інформація</h3>
			<p>Доступ до нашого веб-сайту можна отримати без необхідності надання будь-якої інформації, хоча для реєстрації та / 
				або укласти наші плани, вам потрібно буде надати нам деяку особисту інформацію. Інформація (особиста 
				або неособисті), які збирає Служба, залежно від цього можуть відрізнятися.<br>
				Особиста та неособиста інформація, зібрана Сервісом, надходитиме до нас трьома способами: 1) тим, що 
				збирається автоматично 2) те, що ви надаєте нам добровільно, і 3) те, що надається третіми особами.</p>

			<h5>2.1. Той, який збирається автоматично</h5>
			<p>Ця інформація складатиметься з:</p>
			<ul>
				<li>Те, що збирається за допомогою файлів cookie або подібних механізмів, які зберігаються на вашому пристрої, завжди за вашою згодою або в 
					відповідно до інших правових підстав. Для отримання додаткової інформації ознайомтеся з нашою політикою використання файлів cookie.</li>
				<li>IP-адреса, з якої здійснюється підключення, тип використовуваного пристрою та його характеристики, версія 
					операційна система, тип браузера, мова, дата, країна, час запиту, 
					URL-адреса, з якої ви прийшли, URL-адреса, на яку ви переходите, або використовувана мобільна мережа, серед іншого.</li>
				<li>Дані про використання служби та можливі помилки, виявлені під час її використання.</li>
				<li>Крім того, Remove Background використовує Google Analytics, аналітичну службу Google, LLC. 
					розташована в Сполучених Штатах зі штаб-квартирою за адресою 1600 Amphitheatre Parkway, Mountain View, California 94043. 
					Для надання цих послуг вони використовують файли cookie, які збирають інформацію, включаючи IP-адресу користувача, 
					які будуть передані, оброблені та збережені компанією Google відповідно до умов, встановлених на сайті www.google.com. 
					Включно з можливою передачею зазначеної інформації третім особам на підставі правових вимог або 
					коли треті сторони обробляють інформацію від імені Google.</li>
			</ul>
			<p>У будь-якому випадку ви можете вимкнути файли cookie Google Analytics <a href="{externalLink: disableGoogleAnalyticsLink}">тут</a>.</p>

			<h5>2.2. Той, який ви надаєте добровільно</h5>
			<p>Ця інформація складатиметься з:</p>
			<ul>
				<li>Усі дані є обов’язковими.</li>
				<li>Те, що вимагається Remove Background для завершення вашої реєстрації в Інтернеті: ім’я та прізвище, адреса та електронна пошта тощо.</li>
				<li>Усі дані є обов’язковими.</li>
				<li>Інформація, особиста чи ні, для завершення угоди про надання послуги, наприклад ваша адреса електронної пошти та номер вашої кредитної чи дебетової картки.</li>
				<li>Інформація, особиста чи ні, яку можуть містити повідомлення, надіслані через контактні канали або канали оцінювання, створені в Службі, 
					наприклад ваше ім’я та електронна адреса.</li>
			</ul>

			<h5>2.3. Наданий третіми особами</h5>
			<p>Ця інформація складатиметься з:</p>
			<ul>
				<li>Те, що надається платіжними системами або обробниками кредитних карток, як-от час покупки або її сума.</li>
			</ul>


			<h3>3. Права та цілі</h3>
			<p>Повідомляємо, що заповнення форм є добровільним. Однак якщо ви не заповните необхідні поля 
				(зазвичай позначається зірочкою), використання деяких функцій Сервісу буде неможливим або обмеженим.<br>
				Персональні дані, які ви нам надаєте, будуть включені та оброблені в Реєстрі лікувальних заходів видалення фону 
				щоб мати можливість обслуговувати ваші запити, надавати запитані послуги та тримати вас в курсі питань, пов’язаних з діяльністю 
				компанії та її послуг.<br>
				Ви можете будь-коли скористатися правами доступу, виправлення, видалення, обмеження вашого лікування, 
				заперечення та перенесення ваших персональних даних електронною поштою на адресу: {supportLink} або поштову адресу: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain.<br>
				В обох випадках ви повинні ідентифікувати себе за допомогою свого імені та прізвища, а також копії свого DNI або національного ідентифікаційного номера, якщо це необхідно.<br>
				У випадку, якщо ви надали згоду для певної мети, ви маєте право відкликати згоду в будь-який час, 
				не впливаючи на законність лікування на основі згоди до її відкликання.<br>
				Крім того, якщо ви вважаєте, що є проблема з тим, як Remove Background обробляє ваші дані, 
				ви можете направити свої скарги до відповідного <a href="{knowYourRightsLink}">органу із захисту даних</a>, який є <a href="{aepdLink}">Іспанським агентством із захисту даних</a> 
				зазначений у випадку Іспанії.</p>


			<h3>4. Вік</h3>
			<p>Що стосується використання онлайн-сервісу, ви заявляєте, що досягли повноліття та маєте необхідні юридичні 
				здатність дотримуватися цієї угоди та використовувати сайт відповідно до його умов, які ви повністю 
				зрозуміти і визнати.<br>
				Ви заявляєте, що вся інформація, яку ви надаєте для доступу до Сервісу до та під час його використання, є правдивою та повною 
				і точні.</p>


			<h3>5. Використання даних</h3>
			<p>Видалити фон використовуватиме зібрані дані для:</p>
			<ul>
				<li>Керувати та оновлювати Службу (правовою основою є наш законний інтерес у підтримці та підтримці Служби 
					актуальний і в хорошому стані).</li>
				<li>Вирішіть питання, які ви піднімаєте (правовою основою є наш законний інтерес у виконанні запитів і 
					сумніви наших користувачів).</li>
				<li>Обробляти платежі, які ви робите (правовою основою є договір).</li>
				<li>Надання послуг за контрактом (контракт є юридичною основою).</li>
				<li>Підтримувати безпеку Сервісу, розслідувати незаконні дії, забезпечувати виконання наших умов і положень
					допомога державним органам безпеки в рамках їх можливих розслідувань (правовою базою є наша 
					законний інтерес щодо гарантування та підтримки безпеки Сервісу та його користувачів).</li>
			</ul>
			<p>Видалити фон не використовує автоматичні рішення, хоча може генерувати основні профілі користувачів, 
				правовою основою є наш законний інтерес для комерційних цілей і надання персоналізованих пропозицій.<br>
				Крім того, Remove Background може використовувати інформацію користувача у формі агрегованих та анонімних даних, щоб показати її третім особам. 
				Ви також можете ділитися статистичними та демографічними даними про користувачів та використання ними Сервісу з третім особам. 
				Але все це не дозволить третім сторонам ідентифікувати вашу особу.</p>

			<h5>5.1. В електронних листах і контактних формах</h5>
			<p>Веб-сайт має шифрування SSL, яке дозволяє користувачам безпечно надсилати свої особисті дані через стандартні контактні форми.<br>
				Зібрані персональні дані підлягають автоматизованій обробці та вносяться до відповідних файлів 
				запису про дії з обробки та власником якого є видалення фону.</p>
			<p>У цьому сенсі:</p>
			<ul>
				<li>Ми отримаємо вашу IP-адресу, яка буде використана для перевірки походження повідомлення, щоб запропонувати вам адекватну 
					рекомендації (наприклад, подавайте інформацію правильною мовою) і виявляйте можливі порушення 
					(наприклад, можливі спроби кібератак на Сервіс), а також дані, пов’язані з вашим провайдером.</li>
				<li>Також ви можете надати нам свої дані телефоном, електронною поштою та іншими зазначеними засобами зв’язку.</li>
			</ul>
			<p>Щодо використовуваного засобу оплати:</p>
			<ul>
				<li>Наші постачальники платіжних послуг для оплати надання наших послуг використовують кредитну або дебетову картку. 
					У жодному разі Служба чи її співробітники не матимуть доступу до банківських реквізитів (наприклад, номера кредитної картки) 
					які користувач як клієнт надасть цим третім особам.</li>
			</ul>


			<h3>6. Збереження даних</h3>
			<p>Нижче вказано, як довго зберігаються дані, оброблені Сервісом:</p>
			<ul>
				<li>Дезагреговані дані зберігатимуться без періоду видалення.</li>
				<li>
					Дані клієнта зберігатимуться протягом необхідного мінімуму та можуть зберігатися до:
					<ul>
						<li>5 років, згідно зі ст. 1964 ЦК (особисті позови без спеціального строку).</li>
						<li>6 років, згідно зі ст. 30 Господарського кодексу (наприклад, книги бухгалтерського обліку або рахунки-фактури).</li>
					</ul>
				</li>
				<li>Дані користувачів зберігатимуться протягом максимального періоду 12 місяців, щоб мати можливість виконувати їхні запити.</li>
			</ul>


			<h3>7. Дані передаються третім особам</h3>
			<p>Існують треті сторони, які керують частиною Сервісу.<br>
				Видалити фон вимагає від них дотримання цієї Політики конфіденційності, якщо вона застосовна, на додаток до власної. Однак Remove Background не несе відповідальності за дотримання зазначеної політики.<br>
				За деяких обставин Remove Background може передавати, використовувати або зберігати будь-яку зібрану особисту інформацію третім особам:</p>
			<ul>
				<li>Щоб надати Послугу:</li>
			</ul>
			<p>Постачальники послуг, які виконують функції від нашого імені, наприклад платіжні послуги, веб-хостинг, бізнес-аналітика, обслуговування клієнтів або веб-маркетинг. Ці постачальники послуг можуть збирати інформацію, необхідну для виконання своїх функцій, і мати до неї доступ, але їм заборонено надавати або використовувати інформацію для будь-яких інших цілей.</p>
			<ul>
				<li>Для співпраці з компетентними органами:</li>
			</ul>
			<p>Якщо ми вважаємо, що це обґрунтовано необхідно для задоволення будь-якого закону, судового процесу чи законного інтересу. У будь-якому випадку ми надамо лише суворо необхідну інформацію.</p>


			<h3>8. Заходи безпеки</h3>
			<p>Remove Background вживає всіх технічних і організаційних заходів, необхідних для
				захищати безпеку та цілісність зібраної особистої та неособистої інформації. 
				Як від несанкціонованого доступу, так і від випадкової зміни, втрати чи знищення.<br>
				У будь-якому випадку Remove Background не може гарантувати абсолютну безпеку зібраної інформації, 
				тому ви повинні співпрацювати та завжди використовувати здоровий глузд щодо інформації, яка надається.<br>
				Ви розумієте та визнаєте, що навіть після видалення особиста та неособиста інформація може залишатися 
				залишатися видимим у кеші або якщо інші користувачі скопіювали чи зберегли його.</p>


			<h3>9. Зміни в Політиці конфіденційності</h3>
			<p>Ми можемо оновити цю Політику конфіденційності в майбутньому. Ми повідомимо вас про його зміни, надіславши повідомлення на вказану електронну адресу та / або розмістивши повідомлення у видному місці на нашому веб-сайті.</p>


			<h3>10. Контакт</h3>
			<p>Якщо у вас є запитання щодо цієї Політики конфіденційності, зв’яжіться з нами за адресою:</p>
			<p>Електронна адреса: {supportLink}<br> 
				Адреса: пр. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain.</p>
		`
	},
	gdpr: {
		lastUpdate: 'Востаннє оновлено: 10 червня 2024 р',
		content: `
			<h3>1. Хто несе відповідальність і як з ними зв’язатися?</h3>
			<p>Контролером цього сайту є Remove Background S.L з адресою Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain.</p>
			<p>Ви можете зв’язатися з ним електронною поштою за адресою {supportLink}.</p>

			<h3>2. Які дані збираються?</h3>
			<p>
				Ми автоматично збираємо дані за допомогою файлів cookie, які завантажуємо на ваш пристрій, включно з аналітикою. 
				Ми також збираємо IP-адресу, з якої здійснюється підключення, тип використовуваного пристрою та його характеристики, 
				версія операційної системи, тип браузера, мова, дата, країна, час запиту, 
				URL-адреса, з якої ви перейшли, URL-адреса, на яку ви переходите, або використовувана мобільна мережа, серед іншого.<br>
				Користувач добровільно надає нам певну інформацію, таку як своє ім’я та прізвище, електронну адресу або банківську інформацію 
				щоб мати можливість зв’язатися з нами, зареєструватися в службі або придбати підписку.
			</p>

			<h3>3. Для чого використовуються зібрані дані?</h3>
			<p>
				Сервіс використовуватиме зібрані дані, серед іншого, для адміністрування та оновлення сервісу, відповіді на ваші запити, 
				надсилати вам нашу розсилку та рекламні пропозиції електронною поштою, керувати вашою реєстрацією на платформі, керувати та надавати 
				послуги, пов’язані з вашою підпискою, обробляти зроблені вами платежі та виставляти відповідні рахунки, 
				підтримувати безпеку Сервісу, розслідувати незаконну діяльність, забезпечувати виконання наших умов і положень 
				допомагати державним органам і силам безпеки в рамках їх можливого розслідування.
			</p>

			<h3>4. Як довго вони зберігаються?</h3>
			<ul>
				<li>Дезагреговані дані зберігатимуться без періоду видалення.</li>
				<li>
					Дані клієнта зберігатимуться протягом необхідного мінімуму та можуть зберігатися до:
					<ul>
						<li>5 років, згідно зі ст. 1964 ЦК (особисті позови без спеціального строку).</li>
						<li>6 років, згідно зі ст. 30 Господарського кодексу (наприклад, книги бухгалтерського обліку або рахунок-фактура).</li>
					</ul>
				</li>
				<li>Дані користувачів зберігатимуться протягом максимального періоду 12 місяців для виконання їхніх запитів.</li>
				<li>Дані користувача, завантажені Сервісом на сторінки та профілі в соціальних мережах, зберігатимуться з моменту надання користувачем згоди до моменту його відкликання.</li>
			</ul>

			<h3>5. Які ваші права як користувача?</h3>

			<p>
				Право на доступ: сторона, яка постраждала, має право отримати підтвердження від контролера даних щодо того, чи є 
				чи не обробляються персональні дані щодо нього чи неї.
			</p>
			<p>
				Право на виправлення: постраждала сторона має право без зайвої затримки отримати від контролера даних 
				виправлення персональних даних, які є неточними та безпосередньо стосуються його. Так само зацікавлена сторона буде 
				мають право доповнити неповні персональні дані, у тому числі шляхом подання додаткової декларації.
			</p>
			<p>
				Право на видалення: це право постраждалої сторони отримати без зайвої затримки від контролера даних видалення 
				персональних даних, які його стосуються.
			</p>
			<p>
				Право на обмеження обробки даних: полягає в отриманні обмеження обробки ваших даних відповідальною особою, 
				хоча його застосування має два аспекти: 1) коли ви оскаржуєте точність ваших персональних даних протягом періоду, який дозволяє 
				відповідальна особа для перевірки та 2) Якщо ви заперечуєте проти обробки ваших персональних даних, відповідальна особа 
				виконується на основі законного інтересу або місії суспільного інтересу, тоді як відповідальна особа перевіряє, чи є ці причини 
				переважати над вашим.
			</p>
			<p>
				Право на перенесення даних: це право постраждалої сторони отримувати персональні дані, які її стосуються, 
				які він надав контролеру даних у структурованому форматі для загального використання та механічного зчитування, а також 
				передавати їх іншому контролеру без перешкод контролера, якому вони були надані.
			</p>
			<p>
				У цьому сенсі зацікавлена сторона матиме право на передачу персональних даних безпосередньо від контролера 
				диспетчеру, коли це можливо технічно.
			</p>

			<h3>6. Як ви можете реалізувати свої права?</h3>

			<p>
				Ви можете скористатися своїми правами щодо персональних даних у будь-який час, надіславши електронний лист на адресу: {supportLink} або на поштову адресу: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spain. В обох випадках ви повинні ідентифікувати себе своїм ім'ям та прізвищем, 
				а також копію вашого DNI або національного ідентифікаційного номера, якщо необхідно.<br>
				Крім того, якщо ви вважаєте, що є проблема з тим, як Remove Background обробляє ваші дані, ви можете направити свої претензії 
				відповідному <a href="{knowYourRightsLink}">органу із захисту даних</a>, який є <a href="{aepdLink}">Агентством із захисту даних Іспанії</a> 
				зазначений у випадку Іспанії.
			</p>

			<h3>7. Чи вжито заходів безпеки?</h3>
			<p>
				Служба вживає всіх необхідних технічних та організаційних заходів для захисту безпеки та недоторканості особистої інформації 
				та зібрану інформацію неособистого характеру. Як від несанкціонованого доступу, так і від випадкової зміни, втрати або знищення.<br>
				У будь-якому випадку Служба не може гарантувати абсолютну безпеку зібраної інформації, тому ви повинні співпрацювати та співпрацювати 
				завжди керуйтеся здоровим глуздом щодо спільної інформації.<br>
				Ви розумієте та визнаєте, що навіть після видалення Особиста та неособиста інформація може залишатися доступною для перегляду в кеші або 
				у разі копіювання або зберігання іншими користувачами.
			</p>

			<h3>8. Чи є передача персональних даних чи міжнародна передача?</h3>

			<p>
				Ми не передаємо дані чи міжнародні перекази. Однак є треті особи, які керують частиною Сервісу 
				що ми вимагаємо дотримуватись нашої Політики конфіденційності в тій мірі, в якій вона стосується їх, і що вони мають власну. 
				Ці треті сторони є постачальниками послуг, які виконують функції від нашого імені, наприклад веб-хостинг, 
				аналітичний моніторинг або веб-розробка.<br>
				Крім того, якщо ми вважаємо, що це обґрунтовано необхідно для задоволення будь-якого закону, судового процесу чи законного інтересу. 
				У будь-якому випадку ми надамо лише суворо необхідну інформацію.
			</p>
		`
	},
	cookiesPolicy: {
		lastUpdate: 'Востаннє оновлено: 21 червня 2024 р',
		content: `
			<h3>Підсумок</h3>
			<ul>
			    <li>Використані файли cookie: <strong>власні та сторонні</strong></li>
			    <li>Чи використовуються вони для отримання статистики? <strong>Так, виходячи з нашого законного інтересу в кращому управлінні службою.</strong></li>
			    <li>Сторонні служби, які встановлюють файли cookie через цей веб-сайт: <strong>Google, Google Analytics, Cloudflare та Stripe.</strong></li>
			</ul>

			<h3>Як налаштувати та вимкнути файли cookie</h3>
			<p>
			    Ви можете дозволити, заблокувати або видалити файли cookie, встановлені на вашому пристрої, у веб-браузері. Якщо ви забороняєте встановлення файлів cookie на вашому пристрої, 
			    якість перегляду може погіршитися. Нижче ви можете дізнатися, як налаштувати файли cookie в кожному браузері:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">Edge</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Opera</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			</ul>

			<h3>1. Типи та використання</h3>
			<p>Сервіс використовує власні та сторонні файли cookie для покращення перегляду, надання послуги та отримання статистики щодо використання веб-сайту.</p>

			<h3>2. Що таке файл cookie і для чого він використовується?</h3>
			<p>
			    Файл cookie – це текстовий файл, який надсилається на ваш комп’ютер, мобільний або планшетний веб-браузер і використовується для зберігання та отримання інформації про
			    перегляд завершено. Наприклад, щоб запам’ятати ваше ім’я користувача та пароль або ваші налаштування профілю.
			</p>

			<h3>3. Які існують типи файлів cookie?</h3>
			<p>Відповідно до того, хто ними керує:</p>
			<ul>
			    <li>Власні файли cookie; вони надсилаються до вашого браузера з нашого власного обладнання або веб-доменів.</li>
			    <li>Сторонні файли cookie; вони надсилаються у ваш веб-переглядач із обладнання чи веб-доменів, якими ми не керуємо безпосередньо, а третьою організацією, такою як Google.</li>
			</ul>
			<p>Залежно від того, як довго вони залишаються активними, існують:</p>
			<ul>
			    <li>сеансові файли cookie; вони залишаються у файлі cookie вашого веб-переглядача, доки ви не покинете веб-сайт, тому жодні не залишаються на вашому пристрої.</li>
			    <li>Постійні файли cookie; вони залишаються на вашому пристрої, і наш веб-сайт зчитує їх кожного разу, коли ви робите новий візит. Ці файли cookie перестають працювати після певної дати.</li>
			</ul>
			<p>Зрештою, відповідно до їх призначення ми маємо:</p>
			<ul>
			    <li>Технічні файли cookie; вони покращують перегляд і належне функціонування веб-сайту.</li>
			    <li>Cookie персоналізації; вони дозволяють отримати доступ до послуги з попередньо визначеними характеристиками на основі низки критеріїв.</li>
			    <li>файли cookie аналітики; вони дозволяють вимірювати та статистично аналізувати використання наданої послуги.</li>
			</ul>
			<p>Список сторонніх файлів cookie, які використовує <strong>remove-background.com</strong></p>
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>: їхні файли cookie (NID або CONSENT) дозволяють персоналізувати спосіб відображення реклами за межами Google або зберігати інформацію
			        як-от бажана мова під час відображення результатів пошуку.<br><a href="{externalLink: googleCookieTypes}">Додаткова інформація</a> про типи файлів cookie, які Google використовує в різних службах.
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Analytics</a>: їхні файли cookie (наприклад, _ga) дозволяють підрахувати, скільки разів користувач відвідує веб-сайт, як, коли та звідки.<br>
			        У будь-якому випадку ви можете вимкнути файли cookie Google Analytics <a href="{externalLink: disableGoogleAnalytics}">тут</a>.
			    </li>
			    <li>Cloudflare: щоб дізнатися про політику Cloudflare щодо файлів cookie та їх використання, натисніть <a href="{externalLink: cloudflareCookiesPolicy}">це посилання</a>.</li>
			    <li>Stripe: знайдіть інформацію <a href="{externalLink: stripeCookiesPolicy}">тут</a> про політику щодо файлів cookie та використання Stripe.</li>
			</ul>
		`
	}
};
